import { formatNumber } from '@mais-retorno-front/helpers/util-helpers';
import {
  getUtcDate,
  truncateText,
} from '@mais-retorno-front/libs/util-helpers';
import { TooltipFormatterContextObject } from 'highcharts';

export function renderTooltipFromProfitChartPRimeComponents(
  dataType?: string,
  multiply: number = 1,
  withoutDate: boolean = false
) {
  const { points, x: date }: TooltipFormatterContextObject = this;

  const sortedPoints = sortSeriesByValue(points)
    .map((point: any) => {
      const value = dataType === 'percent' && point.y;

      const valueToRender = value * multiply;

      let renderValue = '';

      switch (dataType) {
        case 'money':
          renderValue = formatNumber(valueToRender, {
            type: 'money',
            thousandMask: true,
          });
          break;
        case 'percent':
          renderValue = formatNumber(valueToRender, {
            type: 'percent',
          });
          break;
        default:
          renderValue = formatNumber(valueToRender, {
            thousandMask: true,
          });
          break;
      }

      return `
      <tr style="font-weight: bold; color: ${point.color}">
        <td style="border-left: 5px solid ${
          point.color
        }; padding-left: 6px">${renderValue}</td>
        <td style="padding-bottom: 3px"> |  ${truncateText(
          point.series.name,
          25
        )}</td>
      </tr>
      `;
    })
    .join('');

  if (withoutDate)
    return `
  <table>
    ${sortedPoints}
  </table>
  `;

  return `
  <span style="font-weight: bold; padding-top: 6px">${getUtcDate(date)}</span>
  <hr />
  <table>
    ${sortedPoints}
  </table>
  `;
}

const sortSeriesByValue = (
  points: Array<TooltipFormatterContextObject>
): Array<TooltipFormatterContextObject> => {
  return points.sort((point1, point2) => point2.y - point1.y);
};

export const hasSelected = (benchmark: string, list: string[]): boolean =>
  !list.find((b) => b === benchmark);
